module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card-header', {
    staticClass: "md-primary header"
  }, [_c('h1', {
    staticClass: "md-title logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.moduleSelected(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "BodyGuard Logo"
    }
  })]), _c('p', [_vm._v("BodyGuard 323 "), _c('span', [_vm._v("ColorVision ™")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc650862"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 764
// module chunks = 0